export enum ChannelOutputPath {
	PreDsp = 'PRE_DIGITAL_SIGNAL_PROCESSING',
	PostDsp = 'POST_DIGITAL_SIGNAL_PROCESSING'
}
